import { render } from "./SameDayTable.vue?vue&type=template&id=44846206&scoped=true"
import script from "./SameDayTable.vue?vue&type=script&lang=js"
export * from "./SameDayTable.vue?vue&type=script&lang=js"

import "./SameDayTable.vue?vue&type=style&index=0&id=44846206&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44846206"]])

export default __exports__